
import React, { useContext, useEffect, useState,useRef } from 'react';
import "./DemandApproval.css";
import { apiurl } from "../../../../../path";
import Application from '../../../StateContext/Application.js';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { SendBack32, ApprovePay32, Excel32, JPG32, PNG32, PDF32, ProjectCreation64, BudgetHeadCreationBlue32, Cancel32, DeleteRed32, EditBlueBlue32, submit, Tax32, UpdateWhite32, EditIcon, DeleteIcon, Edit32WHITE, Delete32WHITE } from '../../../../../public/LoginImages/importimages';
const DemandApproval = () => {

  const operation = useContext(Application);

  const { GetProjectInfo, GetBudgetHeadInfo, DemandCreation, GetDemandApproval, ApproveBills, GetTotalAmountAvailbaleInBank,GetVendorBillsAndDeduction } = operation;

  const [projectId, setProjectId] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [getAvailableBankBalance, SetAvailableBankBalance] = useState([])
  const [BankBalance, setBankBalance] = useState([])
  const [CountBalance, setCountBalance] = useState([])
  const [data, setData] = useState({
    ProjectName: '',
    ProjectID: '',
    PIU: "",
    AvaiableReleaseAmount: 0,
    SelectedDemandAmount: 0,
    Balance: 0,

  });
  const [technicalInwards, setTechnicalInwards] = useState([])
  const [filteredBills2, setFilteredBills2] = useState([]);
  const [fetchSpecificDemandDeductionDetail, setfetchSpecficDemandDeductionDetail] = useState([]);
  const [showspecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState(null);
  const [selectedBillData, setselectedBillData] = useState(null);
  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);
  const billSlipRef = useRef(null);
  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  }

  const FetchData = async () => {
    try {
      let res = await GetDemandApproval();
      let res1 = await GetProjectInfo("null", "all");
      setProjectId(res1);
      setTableData(res);
      console.log(res);
      // setHeadID(res1);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    FetchData()
    GetTotalAmountAvailableInBank()
  }, []);

  const [selectedBills, setSelectedBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [estimateAmount, setEstimateAmount] = useState([])
  const [changeEstimateAmount, setChangeEstimateAmount] = useState([])
  const [budgetDetails, setBudgetDetails] = useState([]);
  const handleCheckboxChange = async (id, ProjectID, BudgetHeadID) => {
    let projectid = {
      PID: ProjectID,
      BID: BudgetHeadID
    }
    const data = await GetProjectInfo(projectid, "getprojectbugetEstimation");
    console.log("dataa22", data);
    setEstimateAmount(data[0].EsitmateAmount);
    setChangeEstimateAmount(data[0].EstimateAmountAfterBill);

    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((ProjectID) => ProjectID !== id) // Remove if already selected
        : [...prevSelected, id] // Add if not selected

    );
    setBudgetDetails((prev) => {
      const newRow = {
        BudgetID: BudgetHeadID,
        EsitmateAmount: data[0].EsitmateAmount,
        EstimateAmountAfterBill: data[0].EstimateAmountAfterBill,
      };

      // If already exists, remove it (deselect)
      if (prev.some((item) => item.BudgetID === BudgetHeadID)) {
        return prev.filter((item) => item.BudgetID !== BudgetHeadID);
      } else {
        return [...prev, newRow];
      }
    });
  };
  console.log("selectedbills", selectedBills);

  const approveSelected = async () => {
    if (selectedBills.length === 0) {
      alert('No bills selected for approval!');
      return;
    }
    console.log(selectedBills);
    setLoading(true); // Start loader
    try {
      let response = await ApproveBills(selectedBills); // Call backend function
      if (response.message) {
        alert(response.message);
        FetchData(); // Refresh the list after approval
      }
      if (response.error) {
        alert(response.error)
        FetchData(); // Refresh the list after approval
      }
    } catch (error) {
      console.error('Error approving bills:', error);
      alert('An error occurred while approving bills.');
    }
    setLoading(false); // Stop loader
  };

  const GetTotalAmountAvailableInBank = async () => {
    let data = await GetTotalAmountAvailbaleInBank()
    console.log("availablebalance-----",data);
    setBankBalance(data.result[0])
    setCountBalance(data.result1[0])
  }
  let TotalPaidCount = BankBalance.AvailableBalanceinBank - CountBalance.SendAmountToVender
  console.log("bankbalnace",BankBalance);
  // const HeadIDFetchOperation = async (ID, piu) => {


  //   if (!ID || !piu) {
  //     console.log("insert all field project ID and Piu")
  //   }

  //   try {
  //     console.log(ID);
  //     if (piu == "ProjectId") {
  //       let res1 = await GetProjectInfo(ID, "DemandGeneration");
  //       console.log("Project ID ingo :: ", res1);
  //       let projectData = res1[0];
  //       setData((prev) => ({
  //         ...prev,
  //         // FinancialYear: projectData.FinancialYear,
  //         ProjectName: projectData.ProjectName,
  //         ProjectID: projectData.ProjectId,
  //         // ProjectCost: projectData.ProjectCost,
  //         piu: projectData.PIU,
  //         // GRCopy: projectData.GRCopy
  //       }))
  //     } else if (piu == "HeadID") {
  //       let res1 = await GetBudgetHeadInfo(ID, 'id');
  //       console.log("Head ID info ", res1);
  //       let HeadData = res1[0];
  //       setData((prev) => ({
  //         ...prev,
  //         BudgetHeadID: HeadData.HeadID,
  //         BudgetHeadName: HeadData.HeadName,
  //         BudgetHeadType: HeadData.HeadType
  //       }))
  //     }
  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // }


  const FetchDemandApprovalData = async (e) => {
    e.preventDefault();
    const { ProjectID } = data
    console.log(ProjectID);

    if (!ProjectID) {
      alert("Required all field priject id");
      return;
    }

    try {
      let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
      console.log(res1);

      let result = res1;
      let ans = result.filter((item) =>
        item.ProjectID == ProjectID
      );

      // setTableData(ans);

      console.log(ans);


    }
    catch (err) {
      console.log(err);
    }


  }


  const TotalAmount = () => {
    const totalAvaiablereleaseAmount = tableData.reduce((acc, item) => acc + Number(item.BillAmount), 0);

    setData((prev) => ({
      ...prev,
      AvaiableReleaseAmount: totalAvaiablereleaseAmount
    }))
  }

  useEffect(() => {
    TotalAmount();
  }, [tableData])

  const TotalSelectedDemandAmount = (amount) => {
    setData((prev) => ({
      ...prev,
      SelectedDemandAmount: Number(prev.SelectedDemandAmount || 0) + Number(amount)
    }))
  }

 const getDemandGenerationListForbillPDF = async (demandId = null) => {
    try {
      const idToUse = demandId || selectedDemandID;
      let data1 = await GetBudgetHeadInfo('null', 'GetDemandGenerationListForbillPDF', idToUse)
      console.log("dataForbillPDF ------------", data1);
      setFilteredBills2(data1);
      return data1;
    } catch (err) {
      console.log("Error in getDemandGenerationListForbillPDF:", err);
      return [];
    }
  }
  const settingshowspecific3 = async (DemandID) => {
    try {
      let res = await GetVendorBillsAndDeduction(DemandID);
      console.log("GetVendorBillsAndDeduction", res);

      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(DemandID);

      const billsForPDF = await getDemandGenerationListForbillPDF(DemandID);
      setShowSpecific(3);

      const filtered = Array.isArray(billsForPDF)
        ? billsForPDF.filter((val) => val.DemandGenerationID == DemandID)
        : [];
      console.log("filtered", filtered);

      setselectedBillData(filtered[0] || null);
    } catch (err) {
      console.log(err);
    }
  };
  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }

    setExportingBillSlipPDF(true);

    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const margin = 5;

      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;

      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;

      const ratio = Math.min(widthRatio, heightRatio);

      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo = selectedBillData?.TransactionNo || selectedDemandID;

      pdf.save(`Bill_Slip_${transactionNo || "MMGSY"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);

      alert("Failed to export bill slip PDF.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };
  const BackFunction = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setselectedBillData({});
    setSelectedDemandID(null);
    setShowSpecific(0);
  };





  return (
    <>
      <div style={{
        backgroundColor: "#efecff",
        width: 'auto',
        maxHeight: "92vh",
        overflowY: "auto",
        fontFamily: "Inter, sans-serif",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "40px 0",
      }}>
         {showspecific === 0 && (
        <div style={{
          backgroundColor: "#ffffff",
          width: "90%",
          maxWidth: "1200px",
          margin: "0 auto",
          borderRadius: "20px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          padding: "40px 60px",
        }}>

          <h3 className='text-center fw-bold' style={{
            fontWeight: "bold",
            color: "black",
            display: "flex",
            justifyContent: 'center',
            alignItems: "center",
          }}><img
              src={"/Demand-Approval-32.png"}
              alt="Project Icon"
              style={{ marginRight: "10px", width: 28, height: 28 }}
            /> Demand Approval</h3>

          <div className="col-11 m-auto text-end my-3">
            <button className='btn btn-success'
              onClick={approveSelected} disabled={loading}
              style={{ cursor: loading ? 'not-allowed' : 'pointer', borderRadius: '15px', backgroundColor: "#39b54a", }}
            ><img src={ApprovePay32} style={{ width: '18px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve & Pay'}
            </button>
            {/* <button className='btn btn-success'>Approve & Pay</button> */}
            <button className='btn mx-2' style={{ color: 'white', background: "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a)", borderRadius: '15px', width: '100px' }}>
              <img src={SendBack32} style={{ marginRight: '8px', width: '18px', filter: 'brightness(0) invert(1)' }} />Back</button>
          </div>



          <div className='DemandElement m-auto'>

            <div className="col-12">
              <div className="row">
                <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                  <table
                    style={{
                      backgroundColor: "white",
                      width: "100%",
                      borderCollapse: "collapse",
                      borderRadius: "8px",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#2ea4e7",
                          color: "white",
                          textAlign: "center",
                          fontWeight: "600",
                        }}
                      >
                        <th style={{ padding: "10px" }}>Available Release Amount</th>
                        <th style={{ padding: "10px" }}>Selected Demand Amount</th>
                        <th style={{ padding: "10px" }}>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ textAlign: "center", backgroundColor: "#f9fbff" }}>
                        <td style={{ padding: "10px" }}>
                          {Number(TotalPaidCount).toLocaleString("en-IN") || 0}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {data.SelectedDemandAmount}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {Number(TotalPaidCount - data.SelectedDemandAmount).toLocaleString("en-IN") || 0}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {tableData.length > 0 && selectedBills.length > 0 && (
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <table
                      style={{
                        backgroundColor: "white",
                        width: "100%",
                        borderCollapse: "collapse",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0 2px 8px rgba(188, 176, 176, 0.1)",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            backgroundColor: "#2ea4e7",
                            color: "white",
                            textAlign: "center",
                            fontWeight: "600",
                          }}
                        >
                          <th style={{ padding: "10px" }}>Budget Head</th>
                          <th style={{ padding: "10px" }}>Estimate Amount</th>
                          <th style={{ padding: "10px" }}>Remaining Estimate Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {budgetDetails.map((row, i) => (
                          <tr
                            key={i}
                            style={{
                              backgroundColor: i % 2 === 0 ? "#f4f7fe" : "white",
                              textAlign: "center",
                            }}
                          >
                            <td style={{ padding: "10px" }}>{row.BudgetID}</td>
                            <td style={{ padding: "10px" }}>
                              {Number(row.EsitmateAmount).toLocaleString("en-IN") || 0}
                            </td>
                            <td style={{ padding: "10px" }}>
                              {Number(row.EstimateAmountAfterBill).toLocaleString("en-IN") || 0}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>


            <div
              style={{
                width: "90%",
                maxWidth: "1100px",
                backgroundColor: "#f3f8fd",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "20px",
                padding: "40px 60px",
                margin: "40px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <form style={{ width: "100%", maxWidth: "900px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "3fr 1fr auto",
                    alignItems: "center",
                    gap: "20px",
                    justifyContent: "center",
                  }}
                >
                  {/* Project Name */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label
                      htmlFor="projectName"
                      style={{
                        fontWeight: "700",
                        marginRight: "10px",
                        color: "#333",
                        minWidth: "120px",
                      }}
                    >
                      Project Name
                    </label>
                    <select
                      name="ProjectID"
                      id="projectName"
                      value={data.ProjectID}
                      onChange={HandleChangeData}
                      style={{
                        flex: 1,
                        border: "1px solid #ccc",
                        borderRadius: "10px",
                        padding: "10px",
                        backgroundColor: "white",
                        fontSize: "14px",
                        width: "100%",
                      }}
                    >
                      <option>Choose Project Name</option>
                      {projectId &&
                        projectId.map((val, index) => (
                          <option key={index} value={val.ProjectId}>
                            {val.ProjectName}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* Budget Head */}
                  {/* <div style={{ display: "flex", alignItems: "center" }}>
        <label
          htmlFor="budgetHead"
          style={{
            fontWeight: "700",
            marginRight: "10px",
            color: "#333",
            minWidth: "110px",
          }}
        >
          Budget Head
        </label>
        <select
          name="BudgetHead"
          id="budgetHead"
          value={data.BudgetHead}
          onChange={HandleChangeData}
          style={{
            flex: 1,
            border: "1px solid #ccc",
            borderRadius: "10px",
            padding: "10px",
            backgroundColor: "white",
            fontSize: "14px",
            width: "100%",
          }}
        >
          <option>Choose Budget Head</option>
          {/* your budget head options 
        </select>
      </div> */}

                  {/* Search Button */}
                  <div style={{ textAlign: "center" }}>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{
                        padding: "10px 25px",
                        fontWeight: "600",
                        borderRadius: "10px",
                        backgroundColor: "#2ea4e7",
                        border: "none",
                        transition: "0.3s ease",
                      }}
                      onMouseOver={(e) => (e.target.style.backgroundColor = "#1e8bcc")}
                      onMouseOut={(e) => (e.target.style.backgroundColor = "#2ea4e7")}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </form>
            </div>



            <div className="col-12">
              <div
                style={{
                  width: "100%",
                  overflowX: "auto",     // enables horizontal scrolling
                  marginTop: "15px",
                  paddingBottom: "10px",
                }}
              >
                <table
                  style={{
                    backgroundColor: "white",
                    width: "100%",
                    minWidth: "1400px",    // ensures table scrolls when content overflows
                    borderCollapse: "collapse",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#2ea4e7",
                        color: "white",
                        fontSize: "13px",
                        fontWeight: 600,
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <th style={{ padding: "10px", width: "5%" }}></th>
                      <th style={{ padding: "10px", width: "10%" }}>Project Name</th>
                      <th style={{ padding: "10px", width: "8%" }}>Implementing Agency</th>
                      <th style={{ padding: "10px", width: "10%" }}>Demand Number</th>
                      {/* <th style={{ padding: "10px", width: "10%" }}>Budget Head Code</th> */}
                      <th style={{ padding: "10px", width: "10%" }}>CRC Code</th>
                      {/* <th style={{ padding: "10px", width: "8%" }}>Bill Type</th> */}
                      <th style={{ padding: "10px", width: "8%" }}>Bill Date</th>
                      <th style={{ padding: "10px", width: "8%" }}>Bill Amount</th>
                      <th style={{ padding: "10px", width: "9%" }}>Deduction</th>
                      <th style={{ padding: "10px", width: "9%" }}>Vendor Name</th>
                      <th style={{ padding: "10px", width: "10%" }}>Bill Copy</th>
                      <th style={{ padding: "10px", width: "12%" }}>Work Order Copy</th>
                      <th style={{padding: "10px", width: "12%" }}>View MAS Slip</th>
                    </tr>
                  </thead>

                  <tbody>
                    {tableData && tableData.length > 0 ? (
                      tableData.map((val, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white",
                            fontSize: "14px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          <td style={{ padding: "10px" }}>
                            <input
                              type="checkbox"
                              style={{
                                height: "1.3rem",
                                width: "1.3rem",
                                cursor: "pointer",
                              }}
                              checked={selectedBills.includes(val.DemandGenerationID)}
                              onChange={(e) => {
                                handleCheckboxChange(
                                  val.DemandGenerationID,
                                  val.ProjectID,
                                  val.BudgetID
                                );
                                TotalSelectedDemandAmount(
                                  e.target.checked ? val.BillAmount : -val.BillAmount
                                );
                              }}
                            />
                          </td>

                          <td style={{ padding: "10px", textAlign: "left" }}>
                            {val.ProjectName}
                          </td>
                          <td style={{ padding: "10px" }}>{val.Agency_Name}</td>
                          <td style={{ padding: "10px" }}>{val.DemandGenerationID}</td>
                          {/* <td style={{ padding: "10px" }}>{val.BudgetID}</td> */}
                          <td style={{ padding: "10px" }}>{val.CRC}</td>
                          {/* <td style={{ padding: "10px" }}>--</td> */}
                          <td style={{ padding: "10px", whiteSpace: 'nowrap' }}><img
                            src={"/Time-32.png"}
                            style={{ marginRight: "5px", width: "15px", height: "15px" }}
                          />
                            {new Date(val.Date).toLocaleString()}
                          </td>
                          <td style={{ padding: "10px" }}>{val.NetPayableAmount}</td>
                          <td style={{ padding: "10px" }}>{val.DeductionAmount}</td>
                          <td style={{ padding: "10px" }}>{val.ContractorName}</td>

                          <td style={{ padding: "10px" }}>
                            {val.UploadBillCopy ? (() => {
                              const ext = val.UploadBillCopy.split('.').pop().toLowerCase();
                              // console.log("ext",ext);
                              
                              let icon;
                              if (ext === "xls" || ext === "xlsx") {
                                icon = Excel32; // 🟢 Replace with your actual XLS icon import
                              } else if (ext === "jpg" || ext === "jpeg") {
                                icon = JPG32; // 🟢 Replace with your actual JPG icon import
                              } else if (ext === "png") {
                                icon = PNG32; // 🟢 Replace with your actual PNG icon import
                              } else if (ext === "pdf") {
                                icon = PDF32; // 🟢 Replace with your actual PNG icon import
                              } else {
                                icon = UpdateWhite32; // default icon (optional)
                              }
                              return (
                                <a
                                  href={`${apiurl}/BillCopyDocsImages/${val.UploadBillCopy}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#044c92",
                                    textDecoration: "none",
                                    fontWeight: "600",
                                  }}
                                >
                                   <img
                                                                src={icon}
                                                                alt={ext + " icon"}
                                                                style={{ width: "20px", height: "20px" }}
                                                            />
                                  {val.UploadBillCopy}
                                </a>);
                            })() : (
                              <span style={{ color: '#d9534f', fontWeight: 700 }}>No File</span>
                            )}
                          </td>

                          <td style={{ padding: "10px" }}>
                            {val.UploadBillCopy ? (() => {
                              const ext = val.UploadBillCopy.split('.').pop().toLowerCase();
                              // console.log("ext",ext);
                              
                              let icon;
                              if (ext === "xls" || ext === "xlsx") {
                                icon = Excel32; // 🟢 Replace with your actual XLS icon import
                              } else if (ext === "jpg" || ext === "jpeg") {
                                icon = JPG32; // 🟢 Replace with your actual JPG icon import
                              } else if (ext === "png") {
                                icon = PNG32; // 🟢 Replace with your actual PNG icon import
                              } else if (ext === "pdf") {
                                icon = PDF32; // 🟢 Replace with your actual PNG icon import
                              } else {
                                icon = UpdateWhite32; // default icon (optional)
                              }
                              return(
                            <a
                              href={`${apiurl}/WorkOrderDocsImages/${val.CopyofWorkOrder}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#044c92",
                                textDecoration: "none",
                                fontWeight: "600",
                              }}
                            >
                               <img
                                                                src={icon}
                                                                alt={ext + " icon"}
                                                                style={{ width: "20px", height: "20px" }}
                                                            />
                              {val.CopyofWorkOrder}
                            </a>);
                             })() : (
                                                    <span style={{ color: '#d9534f', fontWeight: 700 }}>No File</span>
                                                )}
                          </td>
                          <td style={{ fontSize: "12px", padding: "5px" }}>
                                                                <button className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto" style={{ minHeight: "33px", minWidth: "100px", padding: "0.375rem 0.75rem", fontSize: "0.9rem", fontWeight: 400, lineHeight: 1.5, cursor: "pointer", background: "linear-gradient(to right, #38439f, #048ecc)", color: "white", borderRadius: "999px", border: "1px solid transparent" }} onClick={() => settingshowspecific3(val.DemandGenerationID)}>
                                                                    <img src="/view32.png" alt="view" width="15" height="15" />
                                                                    <span>View</span>
                                                                </button>
                                                            </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" style={{ textAlign: "center", padding: "15px" }}>
                          No data found !!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
         )}
          {showspecific === 3 && (
          <>
            <div className="col-12 m-auto">
              <div className="col-12 m-auto my-5 budgetContainer ">
                <div className="m-auto budgetElement">
                  {/* Heading */}

                  {/* TABLE CONTAINER */}
                  <div
                    className="mt-3 d-flex justify-content-between"
                    style={{ position: "relative", alignItems: "center", background: "#fff" }}>
                    {/* TITLE – LEFT */}
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <img src="/Bill-files64.png" alt="" width="26" height="26" />
                      <h5 className="m-0 fw-bold">Bill Slip</h5>
                    </div>
                    {/* BACK BUTTON – TOP RIGHT */}
                    <div className="col-4 pb-3 d-flex justify-content-end gap-2">
                      <button className="btn btn-primary d-flex align-items-center gap-2" style={{ borderRadius: "999px", padding: "6px 22px", fontSize: "14px", zIndex: 10 }} onClick={exportBillSlipPDF} disabled={exportingBillSlipPDF}> {exportingBillSlipPDF ? "Downloading..." : "Download PDF"}</button>
                      <button className="btn btn-danger d-flex align-items-center gap-2" style={{ top: "12px", right: "12px", borderRadius: "999px", padding: "6px 22px", fontSize: "14px", zIndex: 10 }} onClick={BackFunction}> Back </button>
                    </div>
                  </div>
                  <div ref={billSlipRef}>
                    {/* Table Header */}
                    <div className="text-center text-white py-3" style={{ background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)" }} >
                      <h5 className="mb-1 fw-bold">Liability Register System</h5>
                      <div className="fw-semibold"> (Maharashtra urban development department) </div>
                      <div className="fw-bold mt-1">Payment Authority Year 2026-27</div>
                      <div className="fw-bold mt-1"> Agency - {selectedBillData?.PIU || "-"} </div>
                    </div>
                    {/* Body */}
                    <div className="border border-dark p-1">
                      <table className="table mb-0" style={{ fontSize: "14px", border: "none" }}  >
                        <tbody>
                          <tr>
                            <td colSpan={2} className="fw-bold text-center fs-6 p-1"> {" "}  Bill Slip for LRS</td>
                          </tr>
                          {[
                            ["Transcation Number", `${selectedBillData?.BillNumber || selectedDemandID}`],
                            ["Date", selectedBillData?.Date ? new Date(selectedBillData?.Date).toLocaleDateString() : "-"],
                            ["Designation", selectedBillData?.Designation || "-"],
                            ["Budget Head", `${selectedBillData?.BudgetHead}`],
                            ["Project Name", `${selectedBillData?.ProjectName}`],
                            ["Agency Name", `${selectedBillData?.Agency_Name || "-"} `],
                            ["Work Name", `${selectedBillData?.WorkName}`],
                            ["RA Bill", `${selectedBillData?.RABillNumber}`],
                            // ["Voucher No.", `${selectedBillData?.VoucherNo}`],
                            // ["Road Type", `${selectedBillData?.RoadType}`],
                            // ["Package No/Agreement No", `${selectedBillData?.AgreementUID}`],
                            // ["Bill No", `${selectedBillData?.RABillNumber}`],
                            // ["Funding Head", `${selectedBillData?.BudgetID}`],
                            // ["Work Name", `${selectedBillData?.ProjectName}`],
                          ].map(([label, value], index) => (
                            <tr key={index} style={{ border: "1.5px solid #1190CA" }} >
                              <td className="text-start" style={{ width: "30%", backgroundColor: "#EAF3FB", fontWeight: 500, padding: "6px 10px", borderRight: "1.5px solid #1190CA" }}>{label} </td>
                              <td className="text-start" style={{ width: "70%", padding: "6px 10px", backgroundColor: "#FFFFFF" }}> {value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <table className="mt-1" style={{ borderCollapse: "collapse", border: "1px solid #000", width: "100%" }}>
                        <tbody>
                          <tr className="border border-dark">
                            <td className="text-start border border-dark " style={{ width: "30%" }} > Total Bill Amount</td>
                            <td className="text-start border border-dark" style={{ width: "23%" }} >Net Payable</td>
                            <td className="text-start border border-dark" style={{ width: "23%" }} >  Deduction</td>
                          </tr>
                          <tr>
                            <td className="text-start border border-dark">{selectedBillData?.BillAmount} </td>
                            <td className="text-start border border-dark"> {selectedBillData?.NetPayableAmount} </td>
                            <td className="text-start border border-dark">{selectedBillData?.DeductionAmount} </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Vendor Details */}
                      <table className="mt-2" style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                        <tbody>
                          {/* Section Title */}
                          <tr style={{ border: "1.5px solid #1190CA", backgroundColor: "#EAF3FB" }} >
                            <td colSpan="6" style={{ padding: "8px 10px", fontWeight: 600, textAlign: "center" }} > Vendor Details</td>
                          </tr>

                          {/* Column Headers */}
                          <tr style={{ border: "1.5px solid #1190CA" }}>
                            <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }} > Vendor Name</td>
                            <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }} >IFSC Code</td>
                            <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }} > Branch Name </td>
                            <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }} > Account Number</td>
                            <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }} > Amount{" "}</td>
                          </tr>
                          {fetchSpecificDemandDeductionDetail && fetchSpecificDemandDeductionDetail.filter(
                            (val) => val.TypeOfAmount == "Total Amount Payable").map((val, index) => {
                              return (
                                <>
                                  <tr style={{ border: "1.5px solid #1190CA" }} key={index}>
                                    <td style={{ padding: "6px 8px", backgroundColor: "white" }}>{val.Vendor_Company_Name}</td>
                                    <td style={{ padding: "6px 8px", backgroundColor: "white" }}> {val.Bank_IFSC_Code} </td>
                                    <td style={{ padding: "6px 8px", backgroundColor: "white" }}>{val.Branch_Name}</td>
                                    <td style={{ padding: "6px 8px", backgroundColor: "white" }}> {val.Bank_Account_Number}</td>
                                    <td style={{ padding: "6px 8px", backgroundColor: "white" }} >{val.TotalAmount}</td>
                                  </tr>
                                </>
                              );
                            })}
                          {/* <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                          >
                            Shivsai Construction
                          </td>
                          <td className='border border-dark'>AKIPS8199N</td>
                          <td className='border border-dark'>MAHB0001302</td>
                          <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
                          <td className='border border-dark'>2,43,991.0</td>
                          <td className='border border-dark'> 2,43,991.0</td>
                        </tr> */}

                          {/* Total */}
                          <tr style={{ border: "1.5px solid #1190CA" }}>
                            <td style={{ padding: "6px 8px", backgroundColor: "#EAF3FB", fontWeight: 500 }} colSpan={4}> Total</td>
                            <td className="border border-dark">{selectedBillData?.NetPayableAmount} </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="my-2" style={{ width: "100%", borderCollapse: "collapse" }} >
                        <thead>
                          <tr style={{ border: "1.5px solid #1190CA", backgroundColor: "#2f7bbd" }}>
                            <td colSpan="6" style={{ padding: "8px 10px", fontWeight: 600, textAlign: "center", color: "white" }}> Deduction Amount Details</td>
                          </tr>
                          <tr style={{ color: "white", backgroundColor: "#2f7bbd", height: "3rem" }} >
                            <th style={{ minWidth: "60px", padding: "8px" }}> Sr No </th>
                            <th style={{ minWidth: "60px", padding: "8px" }}>  Deduction Type </th>
                            <th style={{ minWidth: "60px", padding: "8px" }}> Deduction Amount{" "}</th>
                            <th style={{ minWidth: "60px", padding: "8px" }}>  Amount Number</th>
                            <th style={{ minWidth: "60px", padding: "8px" }}> IFSC </th>
                          </tr>
                        </thead>
                        <tbody>
                          {fetchSpecificDemandDeductionDetail.filter((val) => val.TypeOfAmount != "Total Amount Payable")?.length == 0 ? (
                            <tr>
                              <td colSpan="30" style={{ textAlign: "center", padding: "20px", backgroundColor: "#f9f9f9" }}> No data available</td>
                            </tr>
                          ) : (
                            fetchSpecificDemandDeductionDetail.filter((val) => val.TypeOfAmount != "Total Amount Payable").map((technicalInwards, index) => {
                              const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr className="px-3" key={index} style={{ borderBottom: "1px solid #3b409e", backgroundColor: bgColor }} >
                                  <td style={{ fontSize: "12px", padding: "5px" }}>{index + 1}</td>
                                  <td style={{ fontSize: "12px", padding: "5px" }}> {technicalInwards.TypeOfAmount} </td>
                                  <td style={{ fontSize: "12px", padding: "5px" }} > {technicalInwards.TotalAmount}</td>
                                  <td style={{ fontSize: "12px", padding: "5px" }}  > {technicalInwards.Bank_Account_Number}</td>
                                  <td style={{ fontSize: "12px", padding: "5px" }} >{technicalInwards.Bank_IFSC_Code}</td>
                                </tr>
                              );
                            })
                          )}
                          <tr style={{ border: "1.5px solid #1190CA", fontWeight: 600, background: "white" }}>
                            <td colSpan="2" style={{ padding: "6px 8px", textAlign: "right" }} > Total</td>
                            <td style={{ padding: "6px 8px" }}>{selectedBillData?.DeductionAmount}</td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Signature grid */}
                      <table style={{ width: "100%" }}>
                        <tbody>
                          {[
                            [
                              {
                                role: "MAKER",
                                rDate: fetchSpecificDemandDeductionDetail[0]
                                  ?.UploadedOn
                                  ? fetchSpecificDemandDeductionDetail[0].UploadedOn.split(
                                    "T",
                                  )[0]
                                  : "-",
                                aDate: fetchSpecificDemandDeductionDetail[0]
                                  ?.GM_Approval_Date
                                  ? fetchSpecificDemandDeductionDetail[0].GM_Approval_Date.split(
                                    "T",
                                  )[0]
                                  : "-",
                              },
                              {
                                role: "Checker",
                                rDate: fetchSpecificDemandDeductionDetail[0]
                                  ?.GM_Approval_Date
                                  ? fetchSpecificDemandDeductionDetail[0].GM_Approval_Date.split(
                                    "T",
                                  )[0]
                                  : "-",
                                aDate: fetchSpecificDemandDeductionDetail[0]
                                  ?.Acnt_Approval_Date
                                  ? fetchSpecificDemandDeductionDetail[0].Acnt_Approval_Date.split(
                                    "T",
                                  )[0]
                                  : "-",
                              },
                            ],
                          ].map((row, rowIndex) => (
                            <div key={rowIndex} className="card d-flex flex-row ">
                              {row.map((cell, colIndex) => (
                                <div className="col-6 text-start mt-5 px-5 mb-2" key={colIndex}>
                                  <div><strong>Signature :</strong></div>
                                  <div>Received Date : {cell.rDate}</div>
                                  <div>Approved Date : {cell.aDate}</div>
                                  <div>Designation : {cell.role}</div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </tbody>
                      </table>

                      {/* Footer */}
                      <div className="row g-0" style={{ borderTop: "1.5px solid #1190CA", minHeight: "120px", padding: "20px 0" }}>
                        <div className="col-2 d-flex flex-column justify-content-center" style={{ alignItems: "flex-start" }}>
                          <div style={{ width: "130px", height: "130px", border: "1px solid #BFC5CC", padding: "4px", backgroundColor: "#fff" }} >
                            <img src="/sample-qr-code.png" alt="Bill QR Code" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                          </div>
                          <div style={{ fontSize: "14px", marginTop: "6px", fontWeight: "500" }} >  Bill QR Code</div>
                        </div>
                        {/* Center text – TOP aligned */}
                        <div className="col-8 px-3" style={{ fontSize: "13px", color: "#333", lineHeight: "1.4", fontWeight: "500", textAlign: "justify", alignSelf: "flex-start", marginTop: "10px" }}></div>
                        {/* Work QR - RIGHT EDGE */}
                        <div className="col-2 d-flex flex-column justify-content-center" style={{ alignItems: "flex-end" }}>
                          <div style={{ width: "130px", height: "130px", border: "1px solid #BFC5CC", padding: "4px", backgroundColor: "#fff" }} >
                            <img src="/sample-qr-code.png" alt="Work QR Code" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                          </div>
                          <div style={{ fontSize: "14px", marginTop: "6px", fontWeight: "500" }} >Work QR Code </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>



    </>
  )
}

export default DemandApproval
